import { useRequest } from "../../../app/hooks/useRequest";
import { getEventLogListRequest } from "../EventLogRequests";

export const useGetEventLogList = () => useRequest(getEventLogListRequest);
